import { render, staticRenderFns } from "./CustomAlert.vue?vue&type=template&id=dfc2e218&scoped=true&"
import script from "./CustomAlert.vue?vue&type=script&lang=js&"
export * from "./CustomAlert.vue?vue&type=script&lang=js&"
import style0 from "./CustomAlert.vue?vue&type=style&index=0&id=dfc2e218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc2e218",
  null
  
)

export default component.exports